// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__QvuQe","skills__body":"Skills_skills__body__YY7Kf","skills__icons":"Skills_skills__icons__Onpub","skills__icon":"Skills_skills__icon__Y2g0x"};